import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var enrollCourseListRes;
export const enrollCourseListTodo = createAsyncThunk('enrollCourseList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/self_reading_course',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return enrollCourseListRes = res.data
    } catch (error) {
        return enrollCourseListRes = error.response.data
    }
})


const enrollCourseListSlice = createSlice({
    name: 'enrollCourseList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(enrollCourseListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('enrollCourseList', state.data)
            }
        });
        builder.addCase(enrollCourseListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default enrollCourseListSlice.reducer; 